// The live sky behind every pre-sign-in screen: the sky phoneware.us draws too (@phoneware/sky), over
// the matching day photo or renderer-derived night frame, with its cloud bank low on either side of the card.
//
// This module is the page load as far as the sky is concerned: it makes the page's sky once, and every SignInCard
// borrows the same one, so moving between sign-in screens keeps the same clouds instead of rebuilding them.
import React, { useLayoutEffect, useRef, useState } from "react";
import { pageSky } from "@phoneware/sky";
import { initTheme } from "./theme.js";

/** The sky the page's sign-in cards share. */
const sky = pageSky();

/** The live sky behind a sign-in card. Renders nothing once the photo has to stand in for it. */
export function LiveSky(): React.ReactElement | null {
  const host = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);
  useLayoutEffect(() => {
    if (!host.current) return undefined;
    const theme = initTheme();
    const appearance = () => sky.setAppearance(theme.state().theme === "dark" ? "night" : "day");
    appearance();
    window.addEventListener("pw-theme-change", appearance);
    const release = sky.borrow(host.current, () => setFailed(true));
    return () => {
      window.removeEventListener("pw-theme-change", appearance);
      release();
    };
  }, []);
  return failed ? null : <div ref={host} className="signin-sky" aria-hidden="true" />;
}
